import * as React from "react";
import * as Yup from "yup";
import { FormikProps, Formik, FormikActions } from "formik";
import Component from "@reach/component-component";

import { IFormikOuterProps } from "src/views/Admin/types";
import {
  IItem,
  IItemTag,
  IFormProps,
  IFormState,
  ITagWithGroup,
  ITagValidation,
} from "../types";

import {
  parameterize,
  deparameterize,
} from "src/views/Admin/services/objectHelpers";
import EditForm from "./EditForm";
import { validateTags } from "../services/validateTags";
import { transformServerValidation } from "../services/transformServerValidation";
import { availableTagGroups } from "../services/availableTagGroups";

export default class Form extends React.Component<IFormProps, IFormState> {
  id = this.props.id;
  tagValidation: ITagValidation<ITagWithGroup> = {
    errors: [],
    warnings: [],
  };
  tagGroupOptions = this.props.tagGroupOptions;

  state: IFormState = {
    withWarnings: false,
    serverTagValidation: {
      warnings: [],
      errors: [],
    },
  };

  schema = Yup.object().shape(
    parameterize(this.id, {
      name: Yup.string().required("Name is required"),
      defaultProfiles: Yup.boolean(),
      defaultItems: Yup.boolean(),
      parameter: Yup.object({
        name: Yup.string().required("Parameter is required"),
      }),
    })
  );

  initialValues = parameterize(this.id, this.props.initialValues) as IItem;

  onSubmit = async (values: IItem, actions: FormikActions<IItem>) => {
    try {
      this.props.preventClosing(false);
      await this.props.onSubmit(
        deparameterize(values) as IItem,
        this.state.withWarnings
      );
    } catch (error) {
      const response = error.response.data;
      if (response.statusCode === 406) {
        this.setState({
          serverTagValidation: transformServerValidation(response.result),
        });
      }
    }
    actions.setSubmitting(false);
  };

  updateDirty = ({
    prevProps,
    props,
  }: {
    prevProps: IFormikOuterProps;
    props: IFormikOuterProps;
  }) => {
    if (prevProps.dirty !== props.dirty) {
      this.props.preventClosing(props.dirty);
    }
  };

  getTagsWithGroup = (tags: IItemTag[]) =>
    tags.map((tag) => ({
      ...tag,
      tagGroup: this.props.tagGroups.find(({ id }) => id === tag.tagGroup.id),
    })) as ITagWithGroup[];

  validateTags = (values: IItem) => {
    const options = availableTagGroups(
      this.getTagsWithGroup(values[`itemTags-${this.id}`]),
      this.props.tagGroupOptions
    );
    const { hasWarnings, validation } = validateTags(
      this.getTagsWithGroup(values[`itemTags-${this.id}`]),
      this.state.serverTagValidation
    );

    this.tagGroupOptions = options;
    this.tagValidation = validation;
    if (this.state.withWarnings !== hasWarnings) {
      this.setState({ withWarnings: hasWarnings });
    }
  };

  formRender = (props: FormikProps<IItem>) => {
    this.validateTags(props.values);

    return (
      <EditForm
        id={this.id}
        tagValidation={this.tagValidation}
        tagGroupOptions={this.tagGroupOptions}
        withWarnings={this.state.withWarnings}
        itemOptionsWithParameter={this.props.itemOptionsWithParameter}
        parameterOptions={this.props.parameterOptions}
        marketOptions={this.props.marketOptions}
        tagGroups={this.props.tagGroups}
        onRemove={this.props.onRemove}
        onToggleArchive={this.props.onToggleArchive}
        isArchive={this.props.isArchive}
        {...props}
      >
        <Component dirty={props.dirty} didUpdate={this.updateDirty} />
      </EditForm>
    );
  };

  render() {
    return (
      <Formik
        initialValues={this.initialValues}
        validationSchema={this.schema}
        onSubmit={this.onSubmit}
        render={this.formRender}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Admin/Items/components/Form.tsx